import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { registerSW } from 'virtual:pwa-register'
import { ErrorBoundary } from './core/oblique-ui/ErrorBoundary.jsx'

// Register Service Worker for PWA with auto-update checking
registerSW({
  immediate: true,
  onRegistered(r) {
    r && setInterval(() => {
      r.update()
    }, 60 * 60 * 1000) // Check for updates every 1 hour
  }
});

// Force page reload when a new service worker takes control (auto-update)
let refreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

// Diagnostic Logging
console.log('[Oblique] main.jsx execution started');

window.addEventListener('error', (event) => {
  if (event.error?.message?.includes('INTERNAL ASSERTION FAILED') || event.message?.includes('INTERNAL ASSERTION FAILED')) {
    console.warn('[Oblique Shield] Intercepted transient Firestore internal assertion failure:', event.error);
    event.preventDefault();
    return;
  }
  console.error('[Oblique Crash] Unhandled error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('INTERNAL ASSERTION FAILED') || String(event.reason)?.includes('INTERNAL ASSERTION FAILED')) {
    console.warn('[Oblique Shield] Intercepted transient Firestore unhandled rejection:', event.reason);
    event.preventDefault();
    return;
  }
  console.error('[Oblique Crash] Unhandled promise rejection:', event.reason);
});

const rootElement = document.getElementById('root');
if (rootElement) {
  console.log('[Oblique] Found root element, starting render...');
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>
    )
    console.log('[Oblique] Render call completed');
  } catch (err) {
    console.error('[Oblique] Render failed:', err);
  }
} else {
  console.error('[Oblique] Root element not found!');
}
